// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2778":"3d58adb5","8124":"1c32f2ac","8846":"3d58adb5","9655":"8431b9ff"}[chunkId] + ".chunk.css";
};